import React from 'react'
import Alternativa from './Alternativa'
import Porcentaje from './Porcentaje'

const Alternativas = ({ data, total, simple }) => {
  return (
    <div className="alternativas">
      {data.map((alternativa, i) => (
        <Alternativa
          key={i}
          enunciado={alternativa.name}
          color={alternativa.color}
          index={i}
          simple={simple}>
          <Porcentaje
            total={total}
            porcion={alternativa.seats.length}
            simple={simple}></Porcentaje>
        </Alternativa>
      ))}
    </div>
  )
}

export default Alternativas
